import React from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/main.scss";

const homeContent = {
  hero: {
    image: "/img/editorial/main-home-hero.jpg",
    title: "EASE IN MOTION",
    cta: "SHOP NEW ARRIVALS",
    to: "/shop?sort=newest",
  },
  categories: [
    {
      title: "SWEATERS",
      image: "/img/editorial/main-category-sweaters.jpg",
      to: "/shop?category=Sweaters",
    },
    {
      title: "PANTS",
      image: "/img/editorial/main-category-pants.jpg",
      to: "/shop?category=Pants",
    },
    {
      title: "KNITWEAR",
      image: "/img/editorial/main-category-knitwear.jpg",
      to: "/shop?tag=knit",
    },
  ],
  summerHero: {
    image: "/img/editorial/main-summer-hero.jpg",
    title: "SUNLIT DAYS",
    cta: "SHOP HERE",
    to: "/shop?tag=summer",
  },
};

function EditorialImage({ src, alt, loading = "lazy" }) {
  const handleError = (event) => {
    event.currentTarget.classList.add("is-unavailable");
  };

  return (
    <img
      src={src}
      alt={alt}
      loading={loading}
      decoding="async"
      onError={handleError}
    />
  );
}

function EditorialCta({ children }) {
  return <span className="main-home__cta">{children}</span>;
}

function HeroPanel({ content, primary = false }) {
  const Heading = primary ? "h1" : "h2";

  return (
    <Link
      className={`main-home__hero main-home__hero--${
        primary ? "primary" : "secondary"
      }`}
      to={content.to}
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label={`${content.title}: ${content.cta}`}
    >
      <EditorialImage
        src={content.image}
        alt={`${siteConfig.brandName} ${content.title.toLowerCase()} editorial`}
        loading={primary ? "eager" : "lazy"}
      />
      <div className="main-home__overlay-content">
        <Heading>{content.title}</Heading>
        <EditorialCta>{content.cta}</EditorialCta>
      </div>
    </Link>
  );
}

function Main() {
  const collection365 = siteConfig.collections.coreLabel;

  return (
    <div className="main main-home">
      <main>
        <HeroPanel content={homeContent.hero} primary />

        <section className="main-home__statement" aria-label="Our philosophy">
          <p>Made for the moments between seasons, plans, and places.</p>
        </section>

        <section className="main-home__categories" aria-label="Shop by category">
          {homeContent.categories.map((category) => (
            <Link
              className="main-home__category"
              to={category.to}
              key={category.title}
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            >
              <EditorialImage
                src={category.image}
                alt={`${category.title.toLowerCase()} collection`}
              />
              <div className="main-home__overlay-content">
                <h2>{category.title}</h2>
                <EditorialCta>SHOP NOW</EditorialCta>
              </div>
            </Link>
          ))}
        </section>

        <HeroPanel content={homeContent.summerHero} />

        <section className="main-home__split" aria-label="The Signature Collection">
          <Link
            className="main-home__square main-home__square--linked"
            to="/shop?tag=signature"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          >
            <EditorialImage
              src="/img/editorial/main-signature-look.jpg"
              alt={`${siteConfig.brandName} Signature collection`}
            />
            <div className="main-home__overlay-content">
              <h2>THE SIGNATURE COLLECTION</h2>
              <EditorialCta>SHOP NOW</EditorialCta>
            </div>
          </Link>

          <figure className="main-home__square main-home__square--still">
            <EditorialImage
              src="/img/editorial/main-layering-still.jpg"
              alt="Relaxed tonal layering in motion"
            />
          </figure>
        </section>

        <section
          className="main-home__split main-home__split--365"
          aria-label={collection365}
        >
          <div className="main-home__square main-home__365-copy">
            <div>
              <p>
                A timeless range of soft essentials, designed to combine freely and
                return to every day of the year.
              </p>
              <Link
                className="main-home__text-link"
                to="/shop?collection=365"
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              >
                DISCOVER {collection365}
              </Link>
            </div>
          </div>

          <Link
            className="main-home__square main-home__square--linked"
            to="/shop?collection=365"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          >
            <EditorialImage
              src="/img/editorial/main-core-essentials.jpg"
              alt={`${collection365} everyday essentials`}
            />
            <div className="main-home__overlay-content">
              <EditorialCta>SHOP {collection365}</EditorialCta>
            </div>
          </Link>
        </section>
      </main>
    </div>
  );
}

export default Main;
